<template>
    <div class="action-table">
        <v-client-table
            :data="tableData"
            :columns="columns"
            :options="options"
            ref="table"
        >
            <colored-letter-square
                slot="cls_column"
                slot-scope="props"
                :name="props.row.variation_name"
                :length="2"
            >
            </colored-letter-square>

            <div slot="actions" slot-scope="props">
                <course-variation-table-actions
                    :data="props.row"
                    :index="props.index"
                ></course-variation-table-actions>
            </div>
        </v-client-table>
    </div>
</template>

<script>
import { Event } from 'vue-tables-2';
import { EventBus } from '../eventbus';

export default {
    props: ['course', 'standardVariation'],

    data() {
        return {
            tableData: [],
            columns: [
                'cls_column',
                'variation_name',
                'title',
                'count_learning_contents',
                'actions',
            ],
            options: {
                headings: {
                    cls_column: '',
                    variation_name: this.trans(
                        'course_variations.label.variation_name'
                    ),
                    title: this.trans('course_variations.label.title'),
                    count_learning_contents: this.trans(
                        'course_variations.label.count_learning_contents'
                    ),
                    actions: this.trans('vuetables.label.actions'),
                },

                texts: {
                    count: this.trans('vuetables.label.countText'),
                    filter: this.trans('vuetables.label.filter'),
                    noResults: this.trans('vuetables.label.loading'),
                    filterPlaceholder: this.trans('vuetables.label.search'),
                },

                sortable: [
                    'variation_name',
                    'title',
                    'count_learning_contents',
                ],

                // Highlight standard variation
                rowClassCallback: row => {
                    if (row.is_default) {
                        return 'highlight';
                    }
                },
            },
        };
    },

    methods: {
        fetch() {
            axios
                .get(
                    this.route(
                        'mainapi.courses.variations.index',
                        this.course.id
                    )
                )
                .then(this.refresh);
        },

        refresh({ data }) {
            // fetch the data
            this.tableData = data.data;

            // change the error text from 'now loding' to 'no match'
            this.options.texts.noResults = this.trans(
                'vuetables.label.noResults'
            );
        },
    },

    created() {
        this.fetch();
    },

    mounted() {
        EventBus.$on('onDelete', deleteId => {
            var index = this.tableData.findIndex(data => data.id == deleteId);
            this.tableData.splice(index, 1);
        });

        var filter = this.debounce(query => {
            this.$refs.table.setFilter(query);
        }, 500);

        EventBus.$on('onFilter', query => {
            filter(query);
        });
    },
};
</script>
